module.exports = {"ru":{"message":"Вы используете неподдерживаемый браузер. Пожалуйста, <a href=\"https://browsehappy.com/?locale=ru\" target=\"_blank\">обновите его или откройте</a> сайт в другом браузере."},"en":{"message":"You are using an unsupported browser. Please <a href=\"https://browsehappy.com/?locale=en\" target=\"_blank\">update your browser, or open</a> the site in another browser."}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/old-browser/text.yaml
// module id = 162
// module chunks = 0